import { Router } from 'framework7/types';
import { AupEntryPage } from '@/components/pages/AupEntry/AupEntryPage';

export const aupRoutes: Router.RouteParameters[] = [
  {
    // GMO決済(paymentRoutes)と同じルータブルPopup方式で開く
    path: '/aup/entry/',
    popup: {
      component: AupEntryPage,
    },
    name: 'aupまもリスCall',
  },
];
